<template>
  <div
    class="h-nav-menu-item"
    :class="[
      {'h-nav-active-item text-primary font-medium' : activeLink},
      {'disabled-item pointer-events-none' : isDisabled},
    ]" >

      <router-link
        v-if="to || name"
        exact
        :class="[{'router-link-active': activeLink}, {'p-2': iconOnly}, 'nav-link flex items-center']"
        :to="to!==null?to:{name: name, query: query}"
        :target="target" >
          <template v-if="icon">
            <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
            <feather-icon v-else :class="!iconOnly ? iconClasses : 'm-auto'" :icon="icon" />
          </template>
          <slot v-if="!iconOnly"/>
      </router-link>

      <a v-else :target="target" :href="href" class="nav-link flex items-center">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="iconClasses" :icon="icon" />
        <slot />
      </a>
  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    iconOnly    : { type: Boolean,                default: false            },
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    name        : { type: [String, null],         default: null             },
    query       : { type: [Object, null],         default: null             },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
  },
  computed: {
    iconClasses() {
      return this.iconSmall ? 'w-3 h-3 mr-3' : 'w-5 h-5 mr-3'
    },
    activeLink() {
      let isCourseRoute = this.to && this.$route.params.course_id === this.to.slice(this.to.lastIndexOf('/')+1,this.to.length)
      return !this.query && this.$route.name === this.name || isCourseRoute || this.to === this.$route.path
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenuItem.scss";
</style>
